const DEFAULT_TIMEOUT = 5000;

export const fetchJson = async <T = unknown>(
  url: string,
  options: { headers?: Record<string, string>; method?: "GET" | "POST"; payload?: string } = {},
  timeout?: number,
): Promise<{ ok: true; data: T } | { ok: false; error: string; status?: number }> => {
  try {
    if (options.payload && options.method !== "POST") {
      throw new Error("Payload is only allowed with POST method");
    }

    const response = await fetch(url, {
      headers: options.headers,
      method: options.method ?? "GET",
      signal: AbortSignal.timeout(timeout ?? DEFAULT_TIMEOUT),
      body: options.payload,
    });

    if (response.ok) {
      const data = (await response.json()) as T;
      return { ok: true, data };
    } else {
      return {
        ok: false,
        error: `Request failed with status ${response.status}`,
        status: response.status,
      };
    }
  } catch (err: unknown) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : "Unknown error",
    };
  }
};
